<style lang="scss" scoped>
.quote-form {
  background-color: #eee;
  padding: 15px 15px 10px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}
.quote-origin {
  text-align: right;
  font-size: 12px;
  margin: 10px 0;
  a {
    color: #333;
  }
}
.quote-preview-text {
  padding: 15px;
  background: #eee;
  font-size: 1.4rem;
  line-height: 2.2rem;
}
.quote-preview-comment {
  font-size: 1.4rem;
  line-height: 2.2rem;
}
</style>

<template>
  <div class="quote-input">
    <div class="quote-form" v-if="isEditing">
      <h2>引用</h2>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          name="quote_url"
          placeholder="引用元のURL"
          v-model="quote_url"
        />
      </div>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          name="quote_link_text"
          placeholder="引用元のリンクテキスト"
          v-model="quote_link_text"
        />
      </div>
      <div class="form-group">
        <textarea
          placeholder="引用文"
          class="form-control"
          name="quote_text"
          cols="30"
          rows="2"
          v-model="quote_text"
        ></textarea>
      </div>
      <div class="form-group">
        <textarea
          placeholder="コメント"
          class="form-control"
          rows="2"
          v-model="comment"
        ></textarea>
      </div>
      <div class="form-group">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="quote-preview input-preview" v-else>
      <div class="quote-preview-wrap">
        <blockquote class="quote-preview-text">
          <i class="fa fa-quote-right"></i>
          {{ quote_text }}
        </blockquote>
        <div class="quote-origin">
          引用元 <a :href="quote_url" target="_blank">{{ quote_link_text || quote_url }}</a>
        </div>
        <div class="quote-preview-comment">{{ comment }}</div>
      </div>
      <footer-menu
        :onBeginEdit="onBeginEdit"
        :onDeleteInput="onDeleteInput"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';
export default {
  props: {
    value: {},
    index: Number,
    id: String,
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          quote_url: this.quote_url,
          quote_link_text: this.quote_link_text,
          quote_text: this.quote_text,
          comment: this.comment,
        },
        action: 'quote',
        id: this.id,
      };
    },
    valid() {
      return this.quote_url.length && this.quote_text.length;
    },
  },
  mounted() {
    this.quote_text = this.value.quote_text;
    this.quote_url = this.value.quote_url;
    this.quote_link_text = this.value.quote_link_text;
    this.comment = this.value.comment;
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (!this.valid) {
        const alertArray = new Array();
        if (!this.quote_url.length) {
          alertArray.push('引用元のURLを入力してください。');
        }
        if (!this.quote_text.length) {
          alertArray.push('引用文を入力してください。');
        }
        alert(alertArray.join('\n'));
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
  data() {
    return {
      isEditing: false,
      quote_url: '',
      quote_link_text: '',
      quote_text: '',
      comment: '',
    };
  },
  components: {
    'footer-menu': footerMenu,
  },
};
</script>
